import { render, staticRenderFns } from "./MessageBoardItem.vue?vue&type=template&id=6652495a&scoped=true"
import script from "./MessageBoardItem.vue?vue&type=script&lang=js"
export * from "./MessageBoardItem.vue?vue&type=script&lang=js"
import style0 from "./MessageBoardItem.vue?vue&type=style&index=0&id=6652495a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6652495a",
  null
  
)

export default component.exports